/* 孟獲（南蠻王） */
import { defineHero, U, P } from '../define.ts';

export default defineHero({
  id: 'menghuo', name: '孟獲', sub: '南蠻王', faction: 'shu', role: '坦克', weapon: 'axe',
  look: { head: 'headband', skin: '#7a4a2e', beard: 'bushy', eye: 'fierce', bulk: 1.2, size: 1.08, fx: '#ffb24a', c: { armor: '#7a5a2a', sleeve: '#5a3a22', cloth: '#8a4a2a', band: '#e9c46a', pants: '#4a2e1e', pole: '#4a2e1e' } },
  skills: [
    ['吞食', 'multi', '一口吞下一名小兵或黃巾賊（對武將無效）。', { x: { k: 'nuke', kill: true, noHero: true }, aim: U(130), cd: [40, 35, 30, 25], mp: 80 }],
    ['召喚戰象', 'summon', '召喚戰象助戰，生命 {800/1000/1200/1400}、攻擊 {32/42/55/65}。', { x: { k: 'summon', hp: [800, 1000, 1200, 1400], atk: [32, 42, 55, 65], dur: 80, size: 30, skin: 'elephant', name: '戰象' }, aim: P(240, 40), cd: 80, mp: 150 }],
    ['雷鳴戰鼓', 'passive', '附近友軍攻擊力 +{6/10/15/20}%。', { pv: { aura: { r: 560, atkP: [6, 10, 15, 20] } } }],
    ['巨獸擊', 'multi', '猛烈撞擊目標，造成 {400/500/600} 傷害並震暈 {2/2.25/2.5} 秒。', { x: { k: 'nuke', dmg: [400, 500, 600], cc: { stun: [2, 2.25, 2.5] }, fx: 'slam' }, aim: U(150), cd: 160, mp: [160, 180, 200], el: 'earth' }],
  ],
});
